module.exports = __webpack_public_path__ + "img/flutterwave_logo.e7eee8fc.png";